import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import InfoCard from '../../components/InfoCard';
import CallToAction from '../../components/CallToAction';
import '../Home.css';

// Import images
import bannerImage from '../../assets/images/banner.jpg';
import ai1 from '../../assets/images/ai1.jpg';
import ai2 from '../../assets/images/ai2.jpg';
import ai3 from '../../assets/images/ai3.jpg';

const HomeEN = () => {
  return (
    <div className="home">
      <Helmet>
        <title>ProgenX - Home | AI-Powered Education Technologies 2025</title>
        <meta name="description" content="ProgenX is an innovative technology company offering AI-powered education technologies and software solutions. We shape the future with personalized learning experiences, smart data analytics, and AI integration, accelerating digital transformation in education." />
        <meta name="keywords" content="progenx, artificial intelligence, education technology, smart data analytics, software solutions, progenx academy, personalized learning, adaptive education, edtech, ai education" />
        <meta property="og:title" content="ProgenX | AI-Powered Education Technologies" />
        <meta property="og:description" content="AI-powered education technologies and software solutions shaping the future." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/en" />
        <meta property="og:image" content="https://progenxacademy.com/banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ProgenX | AI-Powered Education Technologies" />
        <meta name="twitter:description" content="AI-powered education technologies and software solutions." />
        <link rel="canonical" href="https://progenxacademy.com/en" />
        <link rel="alternate" hreflang="tr" href="https://progenxacademy.com" />
        <link rel="alternate" hreflang="en" href="https://progenxacademy.com/en" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "ProgenX",
            "url": "https://progenxacademy.com",
            "logo": "https://progenxacademy.com/logo.png",
            "description": "Technology company offering AI-powered education technologies and software solutions",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Üniversiteler Mah. İhsan Doğramacı Bul. No: 31 İç Kapı No: 20",
              "addressLocality": "Çankaya",
              "addressRegion": "Ankara",
              "addressCountry": "TR"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+90-538-686-54-16",
              "contactType": "customer service",
              "email": "info@progenxacademy.com"
            },
            "sameAs": [
              "https://app.progenxacademy.com"
            ]
          })}
        </script>
      </Helmet>
      
      <Hero 
        title="PROGENX ACADEMY" 
        subtitle={'"The best way to predict the future is to create it." -Peter Drucker & Abraham Lincoln'}
        buttonText="About Us" 
        buttonLink="/en/about" 
        backgroundImage={bannerImage}
        isHomePage={true}
      />
      
      <section className="home-intro">
        <div className="container">
          <h2 className="section-title">Step by Step Towards Your Dream Success!</h2>
          <p className="intro-text">
            ProgenX is here to push the boundaries of learning and guide you every step of the way on your path to success. 
            With our innovative AI-powered solutions, you can find instant answers to your questions and rediscover the power of learning. 
            Difficult questions are now simple for you, because personalized solutions and learning paths for every question are here! 
            We are proud to walk this path to success with you.
          </p>
          
          <div className="card-row">
            <div className="card-column">
              <InfoCard 
                title="Artificial Intelligence in Education Technology" 
                description="We offer AI-powered education solutions to accelerate learning and make education more effective. With our personalized programs that help each student discover their strengths and overcome their challenges, we make success easier. You're in the right place to make a difference in education and achieve the best results at every level."
                image={ai1}
              />
            </div>
            <div className="card-column">
              <InfoCard 
                title="Smart Data Analytics" 
                description="We develop analytical tools that optimize students' learning processes by combining data science and artificial intelligence technologies. With instant feedback and personalized content, it's now much easier to make progress at every step. Every solution is at your fingertips on the path to success!"
                image={ai2}
              />
            </div>
            <div className="card-column">
              <InfoCard 
                title="Software and AI Integration" 
                description="By bringing together artificial intelligence and software, we offer all the tools needed in the learning journey of individuals and institutions. We provide support in a wide range from personalized solutions to questions to performance analysis, and we work to train the leaders of the future. Power in education is with you, success awaits you!"
                image={ai3}
              />
            </div>
          </div>
        </div>
      </section>
      
      <CallToAction 
        title="Step into the Future with Technology, Meet the Power of Innovation!"
        subtitle="Contact us now and let's make your dreams come true."
        buttonText="Contact Us" 
        buttonLink="/en/contact" 
      />
    </div>
  );
};

export default HomeEN;
